// src/pages/Home/MapSection/MapSection.js

import React, { useEffect, useState, useRef } from 'react';
import {
  MapContainer,
  TileLayer,
  GeoJSON,
  Marker,
  Popup
} from 'react-leaflet';
import L from 'leaflet';
import styles from './MapSection.module.css';
import 'leaflet/dist/leaflet.css';
import customGeo from '../../../assets/images/custom.geo.json';

// Fix Leaflet’s default icon URLs
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl:       require('leaflet/dist/images/marker-icon.png'),
  shadowUrl:     require('leaflet/dist/images/marker-shadow.png'),
});

// Bouncing pin via DivIcon
const bouncingIcon = new L.DivIcon({
  className: styles.bouncingPin,
  html: `<div class="${styles.pin}"></div>`,
  iconSize: [20, 20],
  iconAnchor: [10, 20],
});

const DEFAULT_CENTER = [45, 30]; // Istanbul
const DEFAULT_ZOOM = 5;

const MapSection = ({ locations = [] }) => {
  const [mapCenter, setMapCenter] = useState(DEFAULT_CENTER);
  const [countryCenters, setCountryCenters] = useState([]);
  const mapRef = useRef(null);

  // Center map on first provided location
  useEffect(() => {
    if (locations.length) {
      setMapCenter([locations[0].lat, locations[0].lng]);
    }
  }, [locations]);

  // Compute each country's centroid for pin placement
  useEffect(() => {
    const centers = customGeo.features.map((feature, idx) => {
      const layer = L.geoJSON(feature);
      const bounds = layer.getBounds();
      const c = bounds.getCenter();
      const name = feature.properties.name || `country-${idx}`;
      return {
        id: name,
        position: [c.lat, c.lng],
        label: name
      };
    });
    setCountryCenters(centers);
  }, []);

  // Clean up Leaflet map on unmount to avoid "already initialized" errors
  useEffect(() => {
    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  const countryStyle = {
    color: '#0056d2',
    weight: 2,
    fillColor: '#cfe8ff',
    fillOpacity: 0.3
  };

  return (
    <section className={styles.wrapper}>
      <h2 className={styles.title}>GLOBAL HİZMETLERİMİZ</h2>
      <MapContainer
        center={mapCenter}
        zoom={DEFAULT_ZOOM}
        scrollWheelZoom={false}
        zoomControl={true}
        className={styles.map}
        // Capture the Leaflet instance
        whenCreated={mapInstance => {
          mapRef.current = mapInstance;
        }}
      >
        <TileLayer
          attribution="&copy; OpenStreetMap contributors"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <GeoJSON data={customGeo} style={countryStyle} />

        {countryCenters.map(({ id, position, label }) => (
          <Marker
            key={id}
            position={position}
            icon={bouncingIcon}
          >
            <Popup>{label}</Popup>
          </Marker>
        ))}

      </MapContainer>
    </section>
  );
};

export default React.memo(MapSection);
